export default __webpack_public_path__ + "static/media/digital-empire-small-9@2x.9ab3ab01.png";